import { apiSlice, defaultTransformFn } from 'api/apiSlice'
import { MasterCampaignPlan } from 'api/entities/MasterCampaignPlan'

const BASE_URL = 'masterCampaignPlans'

const masterCampaignPlansTags = apiSlice.enhanceEndpoints({
  addTagTypes: ['MasterCampaignPlan']
})

export const masterCampaignPlansApi = masterCampaignPlansTags.injectEndpoints({
  endpoints: builder => ({
    getMasterCampaignPlan: builder.query<MasterCampaignPlan, { publicId: string }>({
      query: ({ publicId }) => ({
        url: `${BASE_URL}/${publicId}`,
        method: 'GET',
        isContext: true,
        isAgency: false
      }),
      providesTags: (_result, _error, request) => [{ type: 'MasterCampaignPlan', id: request.publicId }],
      transformResponse: defaultTransformFn
    })
  })
})

export const { useGetMasterCampaignPlanQuery } = masterCampaignPlansApi
